// Funcții helper pure (formatare date, escapare, validare) — fără dependențe de React.
import { fmConfirm } from './dialog';
import { t } from './i18n';

export const dkStr = (y,m,d) => `${y}-${String(m+1).padStart(2,"0")}-${String(d).padStart(2,"0")}`;

export const todayISO = () => { const n=new Date(); return dkStr(n.getFullYear(),n.getMonth(),n.getDate()); };

export const addDaysISO = (iso,n) => { const[y,m,d]=iso.split("-").map(Number); const dt=new Date(y,m-1,d); dt.setDate(dt.getDate()+n); return dkStr(dt.getFullYear(),dt.getMonth(),dt.getDate()); };

export const fmtD = iso => { if(!iso) return ""; const[y,m,d]=iso.split("-"); return `${d}.${m}.${y}`; };

export const fmtChart = iso => { if(!iso) return ""; const MON=["Ian","Feb","Mar","Apr","Mai","Iun","Iul","Aug","Sep","Oct","Nov","Dec"]; const[y,m,d]=iso.split("-"); return `${+d}${MON[+m-1]}'${y.slice(2)}`; };

export const escapeHtml = (s) => String(s??"").replace(/[&<>"']/g, c => ({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"}[c]));

export const icsEscape = (s) => String(s||"").replace(/([,;\\])/g,"\\$1").replace(/\n/g,"\\n");

export const calcAge = dob => {
  if(!dob) return "";
  let parts = dob.includes(".") ? dob.split(".") : null;
  if(!parts) return "";
  const b = new Date(+parts[2],+parts[1]-1,+parts[0]);
  if(isNaN(b)) return "";
  const n = new Date(); let a = n.getFullYear()-b.getFullYear();
  if(n < new Date(n.getFullYear(),b.getMonth(),b.getDate())) a--;
  return a;
};

export function validatePassword(p) {
  if(!p || p.length<6) return "Parola trebuie să aibă minim 6 caractere.";
  if(!/[A-ZĂÂÎȘȚ]/.test(p)) return "Parola trebuie să conțină cel puțin o literă mare.";
  if(!/[0-9]/.test(p)) return "Parola trebuie să conțină cel puțin o cifră.";
  if(!/[^A-Za-z0-9ĂÂÎȘȚăâîșț]/.test(p)) return "Parola trebuie să conțină cel puțin un semn special (ex: ! @ # ?).";
  return null; // ok
}

export const isValidPhone = p => /^[0-9]{10}$/.test((p||"").replace(/\s/g,""));

// Data (obiect Date) → cheie ISO locală (YYYY-MM-DD), fără fus orar.
export const isoD = d => dkStr(d.getFullYear(), d.getMonth(), d.getDate());

// Coerce la array: AI-ul întoarce uneori un câmp „listă" ca string simplu.
// Fără asta, `x?.length>0 && x.join(...)` trece (string-urile au length) apoi
// `.join`/`.map` aruncă „is not a function" → aplicația se albește (ecran negru).
export const asArr = v => Array.isArray(v) ? v : (v==null || v==="" ? [] : [v]);

// Coerce orice la text afișabil. AI-ul întoarce uneori un element de listă ca OBIECT
// (ex: {analiza, valoare, semnificatie}); randat direct ca `{x}` → React error #31
// (obiectele nu sunt copil valid) → ecran negru. Aici îl aplatizăm la text.
export const toText = x => {
  if(x==null) return "";
  if(typeof x === "string") return x;
  if(typeof x === "number" || typeof x === "boolean") return String(x);
  if(Array.isArray(x)) return x.map(toText).filter(Boolean).join(", ");
  if(typeof x === "object") return Object.values(x).map(toText).filter(Boolean).join(" — ");
  return String(x);
};

// Array de STRING-uri sigur pentru randare (listă AI): coerce la array + fiecare element la text.
export const asStrArr = v => asArr(v).map(toText).filter(Boolean);

// „Pliază" diacriticele + lowercase, pentru căutări insensibile la diacritice
// (ex: „libera" găsește „Liberă"). Fără asta, căutarea nu potrivea decât cu ă/î/ș/ț.
export const foldDia = s => String(s||"").toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g,"");

// Confirmare înainte de ștergere — dialog temizat (fmConfirm). onConfirm rulează doar la „OK".
export function confirmDelete(msg, onConfirm) {
  fmConfirm(msg || t("Ești sigur că vrei să ștergi? Această acțiune nu poate fi anulată."), {danger:true, okText:t("Șterge")})
    .then(ok=>{ if(ok) onConfirm(); });
}

// Nr. de zile din luna (y, m 0-based)
export const getDIM = (y,m) => new Date(y,m+1,0).getDate();
// Ziua săptămânii a primei zile din luna, cu Luni=0 ... Duminică=6
export const getFDOW = (y,m) => { const d=new Date(y,m,1,12,0,0).getDay(); return d===0?6:d-1; };

// Determină dacă un medicament e programat într-o anumită zi (ISO), în funcție de
// tipul de schemă (zilnic, zile din săptămână, interval ore/zile/luni, ciclic). Pură.
export function shouldMedBeActiveOnDate(med, dateISO) {
  const type = med.scheduleType || "daily";
  const startDate = med.startDate || "2000-01-01";
  if(dateISO < startDate) return false;
  // Dacă a fost reactivat, nu apare înainte de data reactivării
  if(med.activeFrom && dateISO < med.activeFrom) return false;
  // Dacă a fost dezactivat, nu apare din ziua dezactivării înainte
  if(med.deactivatedAt && dateISO >= med.deactivatedAt) return false;
  if(type === "ondemand") return false;

  if(type === "weekdays") {
    // JS getDay(): 0=Sun, 1=Mon, 2=Tue, 3=Wed, 4=Thu, 5=Fri, 6=Sat
    // App weekDays[]: 0=Lu, 1=Ma, 2=Mi, 3=Jo, 4=Vi, 5=Sâ, 6=Du
    const jsDay = new Date(dateISO + "T12:00:00").getDay();
    const appDay = jsDay === 0 ? 6 : jsDay - 1; // Sun→6, Mon→0, Tue→1...Sat→5
    return (med.weekDays||[]).includes(appDay);
  }

  if(type === "interval_hours") {
    const hours = parseInt(med.intervalHours,10) || 8;
    const days = Math.round(hours / 24);
    if(days <= 1) return true; // sub 24h = zilnic
    const diffDays = Math.floor((new Date(dateISO + "T12:00:00") - new Date(startDate + "T12:00:00")) / 86400000);
    return diffDays >= 0 && diffDays % days === 0;
  }

  if(type === "interval_days") {
    const every = parseInt(med.intervalDays) || 1;
    const diffDays = Math.floor((new Date(dateISO + "T12:00:00") - new Date(startDate + "T12:00:00")) / 86400000);
    return diffDays >= 0 && diffDays % every === 0;
  }

  if(type === "interval_months") {
    const every = parseInt(med.intervalMonths) || 1;
    const start = new Date(startDate + "T12:00:00");
    const cur = new Date(dateISO + "T12:00:00");
    if(cur.getDate() !== start.getDate()) return false;
    const monthDiff = (cur.getFullYear()-start.getFullYear())*12 + (cur.getMonth()-start.getMonth());
    return monthDiff >= 0 && monthDiff % every === 0;
  }

  if(type === "cyclic") {
    const cyclicOn = parseInt(med.cyclicOn) || 21;
    const cyclicOff = parseInt(med.cyclicOff) || 7;
    const total = cyclicOn + cyclicOff;
    const diffDays = Math.floor((new Date(dateISO + "T12:00:00") - new Date(startDate + "T12:00:00")) / 86400000);
    return diffDays >= 0 && (diffDays % total) < cyclicOn;
  }

  return true; // daily
}
